import xss from 'xss';

const createXssFilter = (options = {}) => {
  const xssProcessor = new xss.FilterXSS({
    whiteList: {
      h1: [],
      h2: ['class'],
      h3: [],
      p: [],
      em: [],
      strong: [],
      blockquote: [],
      ul: [],
      ol: [],
      li: [],
      a: ['href', 'title', 'target'],
      img: ['src', 'alt', 'typeof'],
      picture: [],
      source: ['srcset', 'media', 'type'],
      div: ['class'],
      iframe: ['width', 'height', 'frameborder', 'allowfullscreen', 'src'],
    },
    stripIgnoreTag: true,
    ...options,
  });

  return string => xssProcessor.process(string);
};

export default createXssFilter;
